import { Component } from 'react'
import classNames from 'classnames'
import css from './page-nav.scss'

class PageNav extends Component {
  render() {
    return (
      <ul className={classNames('list-unstyled', css['nav-items'])}>
        {this.props.children}
      </ul>
    )
  }
}

export default PageNav
